"use strict";
module.exports = {
  NODE_ENV: '"production"',
  BASE_API: '"https://www.hnfsom.com/"',
  // BASE_API: '"https://www.hanxin-chip.com/admin/"',
  // BASE:'http://192.168.5.3:88/',
  BASE: "https://www.hnfsom.com/file/",
  // BASE:'"https://www.hanxin-chip.com/file/"'
};



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 1